import { ArrowRight, ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { usePublicContent } from "../hooks/use-public-content";

export const SiteFooter = () => {
  const { data } = usePublicContent();
  const settings = data?.settings;
  return (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-main">
      <div>
        <span className="eyebrow" data-testid="footer-availability-label">Planning a mechanical package?</span>
        <h2 data-testid="footer-heading">Let’s build something<br /><em>that performs.</em></h2>
      </div>
      <Link to="/contact" className="circle-link" data-testid="footer-contact-link" aria-label="Contact NCP Mechanical">
        <ArrowUpRight />
      </Link>
    </div>
    <div className="v2-footer-grid">
      <div className="footer-brand" data-testid="footer-company-name"><img src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" data-testid="footer-logo-image" /><p>Plumbing, heating and ventilation for residential construction.</p></div>
      <div><span>Contact</span>{settings?.contacts?.map((contact, index) => <a key={contact.name} href={`tel:${contact.phone.replace(/\s/g, "")}`} data-testid={`footer-phone-${index + 1}`}><Phone />{contact.phone}</a>)}<a href={`mailto:${settings?.email}`} data-testid="footer-email-link"><Mail />{settings?.email}</a></div>
      <div><span>Office</span><p><MapPin />{settings?.address}</p></div>
      <div><span>Explore</span><Link to="/about">About <ArrowRight /></Link><Link to="/services">Services <ArrowRight /></Link><Link to="/contact">Contact <ArrowRight /></Link></div>
      {settings?.policies?.length > 0 && <div><span>Policies</span>{settings.policies.map((policy) => <Link key={policy.policy_id} to={`/policies/${policy.slug}`}>{policy.title} <ArrowRight /></Link>)}</div>}
    </div>
    <div className="footer-bottom"><p data-testid="footer-copyright">© {new Date().getFullYear()} NCP Mechanical Ltd</p><p>London & South East</p></div>
  </footer>
  );
};